// extracted by mini-css-extract-plugin
export default {"readOnly":"UYP7k8","disabled":"Y1AvYe"};